<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Footer from '@components/global/footer.vue'
import Header from '@components/global/header.vue'
import PaperModal from '@components/global/modals/layouts/PaperModal.vue'
// import CustomCursor from '@components/global/cursors/Cursor.vue'

const global = useGlobalStore()
const route = useRoute()
const noHeader = ref(['castle'])
const noFooter = ref(['playground', 'lost-art', 'castle', 'debug'])
</script>

<template>
	<!-- Modal -->
	<Transition name="cart" :duration="300">
		<PaperModal v-if="global.modal?.name" :key="global.modal.name" />
	</Transition>

	<!-- Header -->
	<Header v-if="route.name ? !noHeader.includes(route.name) : false" />

	<!-- Page -->
	<router-view v-slot="{ Component, route }">
		<transition name="page" mode="out-in">
			<component :is="Component" :key="route.path" />
		</transition>
	</router-view>

	<!-- Footer -->
	<Footer v-if="route.name ? !noFooter.includes(route.name) : false" />

	<!-- Cursor -->
	<!-- <CustomCursor ref="cursorRef" /> -->
</template>
